var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/20/icon_tile_view copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.1923077,6.26923077 L23.5,6.26923077 C24.0522847,6.26923077 24.5,6.71694602 24.5,7.26923077 L24.5,8.34615385 C24.5,8.8984386 24.0522847,9.34615385 23.5,9.34615385 L13.1923077,9.34615385 C12.6400229,9.34615385 12.1923077,8.8984386 12.1923077,8.34615385 L12.1923077,7.26923077 C12.1923077,6.71694602 12.6400229,6.26923077 13.1923077,6.26923077 Z M13.1923077,13.9615385 L23.5,13.9615385 C24.0522847,13.9615385 24.5,14.4092537 24.5,14.9615385 L24.5,16.0384615 C24.5,16.5907463 24.0522847,17.0384615 23.5,17.0384615 L13.1923077,17.0384615 C12.6400229,17.0384615 12.1923077,16.5907463 12.1923077,16.0384615 L12.1923077,14.9615385 C12.1923077,14.4092537 12.6400229,13.9615385 13.1923077,13.9615385 Z M13.1923077,21.6538462 L23.5,21.6538462 C24.0522847,21.6538462 24.5,22.1015614 24.5,22.6538462 L24.5,23.7307692 C24.5,24.283054 24.0522847,24.7307692 23.5,24.7307692 L13.1923077,24.7307692 C12.6400229,24.7307692 12.1923077,24.283054 12.1923077,23.7307692 L12.1923077,22.6538462 C12.1923077,22.1015614 12.6400229,21.6538462 13.1923077,21.6538462 Z M6.5,5.5 L7.11538462,5.5 C8.21995412,5.5 9.11538462,6.3954305 9.11538462,7.5 L9.11538462,8.11538462 C9.11538462,9.21995412 8.21995412,10.1153846 7.11538462,10.1153846 L6.5,10.1153846 C5.3954305,10.1153846 4.5,9.21995412 4.5,8.11538462 L4.5,7.5 C4.5,6.3954305 5.3954305,5.5 6.5,5.5 Z M6.5,13.1923077 L7.11538462,13.1923077 C8.21995412,13.1923077 9.11538462,14.0877382 9.11538462,15.1923077 L9.11538462,15.8076923 C9.11538462,16.9122618 8.21995412,17.8076923 7.11538462,17.8076923 L6.5,17.8076923 C5.3954305,17.8076923 4.5,16.9122618 4.5,15.8076923 L4.5,15.1923077 C4.5,14.0877382 5.3954305,13.1923077 6.5,13.1923077 Z M6.5,20.8846154 L7.11538462,20.8846154 C8.21995412,20.8846154 9.11538462,21.7800459 9.11538462,22.8846154 L9.11538462,23.5 C9.11538462,24.6045695 8.21995412,25.5 7.11538462,25.5 L6.5,25.5 C5.3954305,25.5 4.5,24.6045695 4.5,23.5 L4.5,22.8846154 C4.5,21.7800459 5.3954305,20.8846154 6.5,20.8846154 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Role-management-list",
    transform: "translate(-1334.000000, -223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1330.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#dd7636",
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list_view.3290b6062563ddd5c01a5c5739e118a1.svg";
export { ForwardRef as ReactComponent };